import { DateTimeFormatInfo, getRawDateTimeFormatInfo } from '../../helpers/DateTimeUtility';
import { getFieldFeatures } from '../helpers';
import { FieldFeatures, KeyPath } from '../templateeditor-types';
import { AiTemplateBuilderPayload, AiTemplateEditorAction, DetectedField } from './templateeditor-ai-types';

export type AiTemplateBuilderAction = {
  type: string;
  payload: AiTemplateBuilderPayload;
};

export const TEMPLATE_EDITOR_AI_APPLY_FIELD_SUGGESTION = 'TEMPLATE_EDITOR_AI_APPLY_FIELD_SUGGESTION';

export const applyFieldSuggestion = (
  pageKeyPath: KeyPath,
  field: DetectedField,
  features?: FieldFeatures,
  rawDateFormat?: DateTimeFormatInfo
): AiTemplateEditorAction => {
  const featuresToUse = features ?? getFieldFeatures();
  const rawDateFormatToUse = rawDateFormat ?? getRawDateTimeFormatInfo();

  return {
    type: TEMPLATE_EDITOR_AI_APPLY_FIELD_SUGGESTION,
    payload: { fieldSuggestion: { pageKeyPath, field, features: featuresToUse, rawDateFormat: rawDateFormatToUse } }
  };
};
